import { render, staticRenderFns } from "./HezuoAuthorRule.vue?vue&type=template&id=5a4ff09c&scoped=true&"
import script from "./HezuoAuthorRule.vue?vue&type=script&lang=js&"
export * from "./HezuoAuthorRule.vue?vue&type=script&lang=js&"
import style0 from "./HezuoAuthorRule.vue?vue&type=style&index=0&id=5a4ff09c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4ff09c",
  null
  
)

export default component.exports